






















































import {
    Vue,
    Component,
    Prop,
} from 'vue-property-decorator';
import {
    Timeline,
    TimelineItem
} from "element-ui";

@Component({
    components: {
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
    }
})

export default class RevisionList extends Vue {
    @Prop() isActiveRevision!: boolean;
    @Prop() revisionList!: any[];

    close(): void {
        this.$emit('update:isActiveRevision', false);
    }

    capitalize(string: string) {
        if (typeof string !== 'string') return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    formatText(text: string) {
        return text
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
}
